import { type Database } from "@fitness-app/supabase";

export type SalesSmsTemplateEntity = Database["public"]["Tables"]["sales_sms_template"]["Row"];
export type SalesSmsTemplateInsert = Database["public"]["Tables"]["sales_sms_template"]["Insert"];
export type SalesSmsTemplateUpdate = Database["public"]["Tables"]["sales_sms_template"]["Update"];

/** Template `type` groups the SMS reminders and maps 1:1 to the meeting status markers (ptaszki). */
export enum SalesSmsTemplateType {
  DayBefore = "dayBefore",
  Morning = "morning",
  HourBefore = "hourBefore",
}

export const SALES_SMS_TEMPLATE_TYPE_LABEL: Record<SalesSmsTemplateType, string> = {
  [SalesSmsTemplateType.DayBefore]: "Dzień przed",
  [SalesSmsTemplateType.Morning]: "Rano",
  [SalesSmsTemplateType.HourBefore]: "Godzinę przed",
};

export type SalesSmsTemplate = Omit<SalesSmsTemplateEntity, "type"> & {
  type: SalesSmsTemplateType;
};
